module.exports = __webpack_public_path__ + "5b3d450db520be18d29a7b430481d568.png";